import { render, staticRenderFns } from "./VuesticTooltip.vue?vue&type=template&id=ffb31fe6&scoped=true"
import script from "./VuesticTooltip.vue?vue&type=script&lang=js"
export * from "./VuesticTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb31fe6",
  null
  
)

export default component.exports